class IndexMainSearch extends HTMLElement {

    

    constructor() {
        super();
        
        this.loadingClass = "loading";
        this.searchedClass = "searched";
        this.closingClass = "closing";
        this.searchOpenedClass = "body-search--open"
        this.firstTimeSearchClass = "first-time-search"

        this.locale = (window.theme.apiLocale || 'us').toLowerCase();

        this.selectors = {
            productItem: '.js-index-search-result-item',
            loading: `.${this.loadingClass}`,
            defaultLinks: '.js-default-links-container',
            defaultProducts: '.js-default-products-container'
        }

        this.form = this.querySelector('form');
        this.container = this.querySelector('.js-index-search-container');
        this.contentContainer = this.querySelector('.js-index-search-content-container');

        //get initial height of content container
        this.contentContainerInitialHeight = this.contentContainer.offsetHeight

        this.disclaimerContainer = this.querySelector('.js-index-search-content-disclaimer-container');
        this.searchInput = this.form.querySelector('.js-index-search-input')
        this.submitForm = this.form.querySelector('[type="submit"]');
        this.closeButtons = this.querySelectorAll('.js-index-search-close-icon')
        this.collectionResultsContainer = this.querySelector('.js-index-search-quick-links');
        this.collectionResultsWrapper = this.querySelector('.js-index-search-quick-links-container');
        this.productResultsContainer = this.querySelector('.js-index-search-results-container');
        this.resultsTitleContainer = this.querySelector('.js-index-search-results-header-container');
        this.resultsTitle = this.querySelector('.js-index-search-result-header');
        this.defaultLinks = this.querySelector(this.selectors.defaultLinks)?.innerHTML || "";
        this.defaultProducts = this.querySelector(this.selectors.defaultProducts)?.innerHTML || "";
        this.defaultTitle = this.resultsTitle.innerHTML;
        this.defaultPlaceholder = this.searchInput.placeholder;
        this.resetInputButton = this.querySelector('.js-index-search-form-clear-button');
        this.resultsCount = this.querySelector('.js-search-result-count');
        
        this.productResultsLimit = 20

        this.refinedSearch;
        this.currentSearch;
        this.currentSearchId;

        /** How close (px) to the bottom before we fetch the next batch */
        this.INFINITE_SCROLL_THRESHOLD = 150;
        this.PRODUCT_FETCH_URL = `${window.theme.apiUrl}/api/ai/search/`;

        this.fetchCtrl = null;


        /* ANALYTICS */
        // --- Impression state
        this._impressionsSent = new Set();     // pages we've already logged
        this._impressionObserver = null;
        this._elToPage = new WeakMap();
        this._impressionTimers = new Map();          // track timer for impression
        this.IMP_URL = `${window.theme.apiUrl}/api/ai/search/analytics/impression`;

        // -- Interaction
        this._dwell = new Map();          // handle -> { t0, idleTimer }
        this._sentKeys = new Set();       // `${type}:${this.currentSearchId}:${handle}`
        this.IDLE_MS = 60_000;            // stop view after 60s of no activity
        this.INTER_URL = `${window.theme.apiUrl}/api/ai/search/analytics/interaction`;
        /* END ANALYTICS */

        /* IF SEARCH IS FULL PAGE */
        console.log('This:', this.dataset.fullPage);
        this.isFullPage = this.dataset.fullPage || "false";

        
        //init analytics service
        this.analyticsService = new window.AnalyticsService({
            impressionUrl: this.IMP_URL,
            interactionUrl: this.INTER_URL,
            idleMs: 15000,
            currency: window.theme?.currency || 'USD'
        });

        //give analytics to document if full page because there's no scrollable container
        const analyticsResultsContainer = this.isFullPage == "true" ? document : this.productResultsContainer;

        console.log('analytics container: ', analyticsResultsContainer)

        this.analyticsService.configureImpressions({
            container: analyticsResultsContainer,
            limit: this.productResultsLimit,
            productItemSelector: this.selectors.productItem,
            loadingClass: this.loadingClass
        });

        this.init();
    }

    connectedCallback() {

        
        /* Attach once when the element hits the DOM */
        if (!this._infiniteScrollBound) {
            this._infiniteScrollBound = this.handleInfiniteScroll.bind(this);

            if (this.isFullPage == "false") {
                this.productResultsContainer.addEventListener('scroll', this._infiniteScrollBound, { passive: true });
            } else {
                window.addEventListener('scroll', this._infiniteScrollBound, { passive: true });
                window.addEventListener('resize', this._infiniteScrollBound, { passive: true });
            }
        }

        // Desktop wheel scroll redirection
        this.container.addEventListener('wheel', (e) => {
            // Only run if there is vertical scroll content
            if (!this.productResultsContainer.contains(e.target) && this.productResultsContainer.scrollHeight > this.productResultsContainer.clientHeight) {
                e.preventDefault();
                this.productResultsContainer.scrollTop += e.deltaY;
            }
        }, { passive: false });


        // in init() or connectedCallback()
        this._onPageHide = (ev) => {
            // Abort any in-flight fetches
            this.fetchCtrl?.abort('pagehide');
        
            // (optional) stop analytics views cleanly
            this._stopAllViews?.('navigate');
        };
        
        window.addEventListener('pagehide', this._onPageHide, { once: true });
    }

    disconnectedCallback() {
        window.removeEventListener('pagehide', this._onPageHide);
    }

    init() {
        //console.log('init search');
        this._resetPagination();
        this.cleanOldSearchCache();

        this.form.addEventListener('submit', this.handleSubmit.bind(this));
        this.searchInput.addEventListener('keydown', this.handleInputChange.bind(this));
        
        /* Not needed if it's full page */
        if(this.isFullPage == "false") {
            this.searchInput.addEventListener('focus', this.handleInputFocus.bind(this));
            this.searchInput.addEventListener('blur', this.handleInputBlur.bind(this));

            document.addEventListener('keydown', this.handleEscClose.bind(this));
            document.addEventListener('click', this.handleOutsideClick.bind(this), true);

            this.closeButtons.forEach((button) => {
                button.addEventListener('click', this.handleClose.bind(this));
            })
        }


        //add event handling for trending search
        this.querySelectorAll('.js-trending-search-item').forEach((item) => {
            item.addEventListener('click', this.handleTrendingSearchClick.bind(this));
        })

        if(this.resetInputButton) this.resetInputButton.addEventListener('click', this.handleInputReset.bind(this));
        

        //window.addEventListener('resize', debounce(this.initSlider.bind(this), 500))

        //calculate initial top position of the search form on Mobile
        //PUT ABOVE RESTORE SEARCH so i can calculate position of search form first
        this.placeSearchForm();
        window.addEventListener('resize', debounce(this.placeSearchForm.bind(this), 500))

        // Check URL for initial search param
        const urlParams = new URLSearchParams(window.location.search);
        const initialQuery = urlParams.get('search');
        if (initialQuery) {
            this.restoreSearchFromHistory(initialQuery)
        }

        // Listen for back/forward navigation
        window.addEventListener('popstate', (event) => {
            //abort existing connection first
            this.fetchCtrl?.abort('popstate');

            const st = event.state || {};

            console.log('sthere', st);

            // Ignore popstates that are unrelated to search (e.g., qv only)
            if (!('search' in st)) {
                this.resetSearchUI();
                return;
            }

            console.log('sthere', st);

            const q = st.search?.query || '';
            
            //make case insensitive
            const l_s = this.currentSearch.toLowerCase();
            const l_q = q.toLowerCase();

            console.log('q', l_q, l_s);

            if (q && l_s != l_q) {
                this.restoreSearchFromHistory(q);
            } else if (!q) {
                this.resetSearchUI();
            }
        });

        //add event tracking to the product
        this.productResultsContainer.addEventListener('click', this.handleQVClick.bind(this));

        //hide and show intercom
        this.handleIntercom();

        //init placeholder
        this.changePlaceholder();
        
    }

    placeSearchForm(){
        const windowWidth = window.innerWidth;
        if (windowWidth < 768) {
            const elementHeight = this.offsetHeight;
            const svh = window.innerHeight;
            const containerHeight = this.contentContainerInitialHeight;

            console.log(elementHeight, svh);

            //const top = elementHeight - containerHeight + 40;


            //set top for IOS initially
            let top = elementHeight - containerHeight - 14;

            //svh is only greater than element height on IOS
            if(elementHeight <= svh){
                top = elementHeight - containerHeight + 40;
            }

            this.contentContainer.style.top = `${top}px`;
        }
    }

    handleTrendingSearchClick(event) {
        const element = event.target
        const search = element.dataset.search || "";

        if (!search) return

        this.searchInput.value = search
        
        this.form.requestSubmit();
    }

    handleEscClose(event) {
        if (event.key === "Escape" &&
            this.classList.contains(this.searchedClass) &&
            !document.querySelector('body').classList.contains('qv--open')
            
        ) {
            console.log('handle close');
            this.handleClose()
        }
    }

    handleInputReset(event){
        event.preventDefault();
        event.stopPropagation();

        //clear signal
        // ① stop in-flight network activity
        if (this.fetchCtrl) this.fetchCtrl.abort();

        this.searchInput.value = '';
        this.resultsTitle.innerHTML = "";
        this.productResultsContainer.innerHTML = "";
        this.collectionResultsContainer.innerHTML = ""
        this.resultsCount.innerHTML = ""
        this.classList.add(this.firstTimeSearchClass);

    }

    handleOutsideClick(event) {

        const body = document.querySelector('body');

        if (
            !this.container.contains(event.target) &&
            this.classList.contains(this.searchedClass) &&
            !body.classList.contains('qv--open') &&
            !body.classList.contains('drawer-open')
        ) {
            //event.stopPropagation();
            this.handleClose();
        }
    }

    disableBodyScroll(){

        if(this.isFullPage == "true") return;


        //body scroll lock
        bodyScrollLock.disableBodyScroll(this.productResultsContainer);
        bodyScrollLock.disableBodyScroll(this.collectionResultsContainer, { allowTouchMove: () => true });

        document.querySelector('body').classList.add(this.searchOpenedClass); 
        document.querySelector('html').classList.add(this.searchOpenedClass);
    }

    handleInputFocus() {
        this.classList.add('search-active');

        // Always scroll section to top on focus
        const rect = this.getBoundingClientRect();
        const offsetTop = window.scrollY + rect.top;

        // Jump instantly (no smooth) so it's ready before VKB shift
        window.scrollTo({
            top: offsetTop,
            behavior: 'instant' // or 'auto'
        });
        
        //open trending searches
        if (!this.classList.contains(this.searchedClass)) {
            this.classList.add(this.firstTimeSearchClass);
        }

        this.classList.add(this.searchedClass);

        this.disableBodyScroll();

        
    }

    handleInputBlur() {
        this.classList.remove('search-active');
    }

    handleQVClick(event){
      const qvTrigger = event.target.closest('.js-open-qv');
      if (qvTrigger) {
        this.handleProductView(qvTrigger);
        // your logic here
      }
    }

    handleProductView(element){
      const handle = element.dataset.handle;

      this.analyticsService.trackClick(handle)
    
    }

    handleIntercom(){
    
        if (this._intercomObserver) return;

        const targetEl = this; // replace with a real element, e.g. this.$refs.searchContainer

        // --- config ---
        const SHOW_T = 0.10;   // show launcher when < 15% visible
        const HIDE_T = 0.35;   // hide launcher when > 35% visible  (hysteresis gap)
        const DELAY  = 500;    // ms dwell/debounce before applying change
        const BOTTOM_INSET = 48; // px; approx launcher height
        // ---------------

        let hidden = null;       // current applied state: true=hidden, false=shown
        let timer = null;        // debounce handle

        const apply = (nextHidden) => {
            if (hidden === nextHidden) return;    // no-op if nothing changed
            hidden = nextHidden;
            window.Intercom?.('update', { hide_default_launcher: hidden });
        };

        const schedule = (nextHidden) => {
            clearTimeout(timer);
            timer = setTimeout(() => apply(nextHidden), DELAY);
        };

        const io = new IntersectionObserver(([entry]) => {
            const r = entry.intersectionRatio;

            // Initialize from first measurement so we don't thrash on load
            if (hidden === null) hidden = r >= HIDE_T;

            // Hysteresis: different thresholds for hide vs show
            if (r >= HIDE_T && hidden !== true) {
            schedule(true);   // section sufficiently visible -> hide launcher
            } else if (r <= SHOW_T && hidden !== false) {
            schedule(false);  // section mostly off screen -> show launcher
            }
        }, {
            root: null,
            // Move the bottom boundary up so toggling doesn't happen right at the tab bar
            rootMargin: `0px 0px -${BOTTOM_INSET}px 0px`,
            threshold: [0, SHOW_T, HIDE_T, 1]
        });

        io.observe(targetEl);
        this._intercomObserver = io;

        // Optional: cleanup hook if your framework supports it
        this._destroyIntercomObserver = () => io.disconnect();
    }

    handleClose() {
        //don't use if full page
        if (this.isFullPage == "true") return;

        // ① stop in-flight network activity
        if (this.fetchCtrl) this.fetchCtrl.abort();


        // Clear the URL parameter
        console.log('handle close');
        const url = new URL(window.location.href);
        url.searchParams.delete('search');
        history.pushState({}, '', url.toString());
        
        //remove products and collections
        this.productResultsContainer.innerHTML = "";
        this.collectionResultsContainer.innerHTML = "";
    
        // Clear input value
        this.searchInput.value = '';

        //reset min height
        this.container.style.minHeight = "auto";

        this.classList.add(this.closingClass);

        this.classList.remove(this.searchedClass);
        this.classList.remove(this.firstTimeSearchClass);
        
        //return to normal scrolling
        document.querySelector('body').classList.remove(this.searchOpenedClass); 
        document.querySelector('html').classList.remove(this.searchOpenedClass);

        // Remove 'searched' class
        setTimeout(function(){ 
            this.classList.remove(this.closingClass);
        }.bind(this), 1000)
        
        //disable body scroll lock
        bodyScrollLock.clearAllBodyScrollLocks();

        //clean analytics observer
        if (this._impressionObserver) {
            this._impressionObserver.disconnect();
            this._impressionObserver = null;
          }
          this._impressionsSent.clear();
          this._elToPage = new WeakMap();
      
    }

    changePlaceholder(){
        const windowWidth = window.innerWidth
        if(windowWidth < 768){
            this.searchInput.placeholder = window.theme.strings.mainSearch.placeholder_mobile;
        }else{
            this.searchInput.placeholder = window.theme.strings.mainSearch.placeholder;
        }
    }

    handleInputChange(event) {
        
        /*
        switch (event.code) {
            case 'Enter':
                event.preventDefault();
                this.handleSubmit(event);
                break;
        }*/

       // For textarea, intercept only plain Enter (not Shift+Enter)
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            this.handleSubmit(event);
        }      
    }

    handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        if (!this.form.checkValidity()) {
            this.form.reportValidity(); // shows native validation message
            return;
        }

        const query = this.searchInput.value;
        this.currentSearch = query;

        console.log('search', query);

        // Scroll results into view
        this.scrollResultsIntoView();

        
        //init search elements
        this.startSearch();
        this.search(query);

        // Push to history and update URL
        const url = new URL(window.location.href);
        url.searchParams.set('search', query);

        //push to history
        pushStateMerge({ search: { query } }, url);

        // Pre-cache with empty data
        localStorage.setItem(`search:${query}:locale:${this.locale}`, JSON.stringify({
            timestamp: Date.now(),
            data: null
        }));
    }

    startSearch() {

        this._resetPagination();
        this._newFetchController();
        this.disableInputs();


        //add searched class
        this.classList.add(this.searchedClass);

        this.disableBodyScroll();

        //remove first time search
        this.classList.remove(this.firstTimeSearchClass);


        //clear product results
        this.productResultsContainer.innerHTML = '';

        this.resultsTitle.innerHTML = this.defaultTitle;

        //clear product results count
        this.updateResultsCount(0);

        //update fetching to true
        this.isFetchingMore = true;

        //reset impressions
        this.analyticsService.resetImpressions();

    }

    disableInputs() {
        this.searchInput.disabled = true;
        this.submitForm.disabled = true;
    }

    enableInputs() {
        this.searchInput.disabled = false;
        this.submitForm.disabled = false;
    }

    search(query) {

        //add loading class
        this.classList.add(this.loadingClass);

        const limit = this.productResultsLimit;
        
        const locale = window.theme.apiLocale || 'us';

        //omit search id for search because it's a new search
        const params = new URLSearchParams({
            search: query,
            limit,
            locale: locale.toLowerCase()
        }).toString();
        
        const ctrl = this.fetchCtrl;
        fetch(`${this.PRODUCT_FETCH_URL}?${params}`, {
            credentials: 'include',
            signal: ctrl.signal
        })
        .then((response) => {
            //console.log('res', response);
            //alert(response)
            if (!response.ok) {
                var error = new Error(response.status);
                throw error;
            }
            //console.log('res ok');
            return response.json();
        })
        .then((response) => {
            //console.log(response);
            const { products, search } = response;

            // Cache in localStorage
            const cached = localStorage.getItem(`search:${query}:locale:${this.locale}`);
            if (cached) {
                const parsed = JSON.parse(cached);
                parsed.data = response;
                localStorage.setItem(`search:${query}:locale:${this.locale}`, JSON.stringify(parsed));
            }

            if (search == "no results" || !products || products.length == 0) {
                this.handleNoResults();
            } else {
                this.handleSearchReturn(response);
            }
        
        })
        .catch((error) => {
            console.log(error);

            if (error.name === 'AbortError') return;

            if (error?.code === 20) {
                // Code 20 means the call was aborted
                return;
            }

            this.handleNoResults();

            throw error;
        })
        .finally(() => {
            this.finalizeSeach();
        });
        
        
    }

    restoreSearchFromHistory(query) {
        this.searchInput.value = this.currentSearch = query;
        this.startSearch();

        console.log('restore from search');

        const cached = localStorage.getItem(`search:${query}:locale:${this.locale}`);
        if (cached) {
            const parsed = JSON.parse(cached);
            if (parsed.data) {
                setTimeout(() => {
                    const data = parsed.data
                    const { products, search } = data;
                    
                    if (search == "no results" || !products || products.length == 0) {
                        this.handleNoResults();
                    } else {
                        this.handleSearchReturn(data);
                    }

                    this.finalizeSeach();
                    return;
                }, 3000);
                
                return;
            }
        }

        console.log('restore from searc2');

        // If not cached or no data yet, fallback to live search
        this.search(query);
    }

    //always run after search is complete
    finalizeSeach(){
        this.enableInputs();
        this.classList.remove(this.loadingClass);
        //always set fetching to false after;
        this.isFetchingMore = false;
        //this.resizeContainer();
    }

    resetSearchUI() {
        /*
        this.classList.remove(this.searchedClass);
        this.classList.remove(this.firstTimeSearchClass)
        this.searchInput.value = '';
        this.resultsTitle.innerHTML = this.defaultTitle;
        this.productResultsContainer.innerHTML = this.defaultProducts;
        this.collectionResultsContainer.innerHTML = this.defaultLinks;
        this.collectionResultsWrapper.classList.remove('hidden');
        */
       this.handleClose();
    }

    //delete entries older than 1 day
    cleanOldSearchCache() {
        const now = Date.now();
        const oneDay = 24 * 60 * 60 * 1000;

        for (let key in localStorage) {
            if (key.startsWith('search:')) {
            try {
                const parsed = JSON.parse(localStorage.getItem(key));
                if (parsed.timestamp && now - parsed.timestamp > oneDay) {
                localStorage.removeItem(key);
                }
            } catch (e) {
                localStorage.removeItem(key);
            }
            }
        }
    }

    handleNoResults() {
        console.log('no results')
        const noResultTitle = window.theme.strings.mainSearch.no_results || "Your search did not yield any results."
        this.handleTitleChange(noResultTitle);
        this.productResultsContainer.innerHTML = this.defaultProducts;
        //this.collectionResultsContainer.innerHTML = this.defaultLinks;

        // Explicitly pass 0 results
        this.updateLiveRegion(0, 0);

        //clear product results count
        this.updateResultsCount(0);
        
    }

    handleSearchReturn(data) {
        const { collections, title, products, search, searchId, pagination } = data;

        //init actual search query used;
        this.refinedSearch = search;
        this.currentSearchId = searchId;
        //also set analytics searchid
        this.analyticsService.setSearchId(this.currentSearchId);

        this.handleCollectionResults(collections);
        this.handleTitleChange(title)
        this.handleProductResults(products);
        this._updatePaginationInfo(pagination, products.length);

        // Live region update with both counts
        const productCount = pagination?.total || 0;
        const collectionCount = Array.isArray(collections) ? collections.length : 0;
      
        this.updateLiveRegion(productCount, collectionCount);
        this.updateResultsCount(productCount);
        
        // Scroll results into view
        this.scrollResultsIntoView();

        this.resizeContainer();

        
        // NEW: schedule impression for the first page once it’s visible
        const initialPage = (pagination && Number.isInteger(pagination.page)) ? pagination.page : 0;
        this.analyticsService.observeItemsInPage(initialPage);

    }


    updateResultsCount(productCount) {
        const resultsCount = this.resultsCount;
        if (productCount > 0) {
            resultsCount.innerHTML = `— ${productCount} ${window.theme.strings.mainSearch.results_count_suffix}`
        } else {
            resultsCount.innerHTML = '';
        }
        
    }

    handleTitleChange(title) { 
        const titleTemplate = `${title} — <span class="js-index-search-results-count index-search-results-count"></span>`
        this.resultsTitle.innerHTML = title;
    }

    handleCollectionResults(collections) {
        let results = ''

        if (collections && collections.length == 0) {
            this.collectionResultsWrapper.classList.add('hidden');
            return;
        } else {
            this.collectionResultsWrapper.classList.remove('hidden');
        }
        

        collections?.forEach((collection) => {
            const url = `/collections/${collection.handle}`
            const template = `<li class="index-search-quick-link glass-effect">
                <a target="_blank" href="${url}">${collection.title}</a>
            </li>`

            results += template;
        })

        this.collectionResultsContainer.innerHTML = results
    }

    handleProductResults(products, append = false) {
        if (!append) this.clearProductResults();  

        const button_text = window.theme.strings.mainSearch.button_text || "Shop Now"

        products.forEach((product, i) => {
            const amount = Number.parseFloat(product.priceRangeV2?.minVariantPrice.amount).toFixed(2);
            const imgUrl   = `${product.featuredImage?.url}&width=800`;
            let money    = slate.Currency.formatMoney(
                                amount.toString(),
                                theme.moneyFormat
            );
            const label = product.metafields?.label_2;

            let isOutofStock = false;
            if (product.totalInventory && product.totalInventory <= 0) {
                isOutofStock = true;
                money = window.theme?.strings?.mainSearch?.out_of_stock || "Sold out"
            }

            const template = `
            <a href="${window.routes.root_url}/products/${product.handle}"
                class="js-open-qv"
                data-handle="${product.handle}"
                data-ai-query="${this.refinedSearch}"
                data-ai-search-id="${this.currentSearchId}">
                    <div class="index-search-result-item-image-container responsive-media-container">
                        <img height="800" width="800" src="${imgUrl}" alt="${product.title} product image">
                    </div>
                    <div class="index-search-result-item-content-container">
                        <h3 class="index-search-result-item-title">${product.title}</h3>
                        ${label ? `<div class="index-search-result-item-label">${label}</div>`: ''}
                        <div class="product__badge">
                            <div
                            data-bv-show="inline_rating"
                            data-bv-product-id="${product.legacyResourceId}"
                            data-bv-seo="false"></div>
                        </div>
                        <div class="index-search-result-item-price-container">
                            <span class="price"><span class="money">${money}</span></span>
                        </div>
                        <span class="index-search-result-item-button btn__underline-animation reverse">${button_text}</span>
                        ${ i == 0 && !append ? `<span class="index-search-result-item-footer-text">${window.theme.strings.mainSearch.why_selected_text}</span>` : ""}
                    </div>
            </a>`;

            /* Fill an existing “loading” block first, else append a new one */
            let block = this.productResultsContainer.querySelector(
                        `${this.selectors.productItem}.${this.loadingClass}`
                        );
            if (!block) {
                block = document.createElement('div');
                block.classList.add('index-search-result-item',
                                    'js-index-search-result-item',
                                    'glass-effect');
                
                if (isOutofStock) {
                    block.classList.add('index-search-result-item--out-of-stock')
                }
                    
                this.productResultsContainer.appendChild(block);
            }
            block.innerHTML = template;
            block.classList.remove(this.loadingClass);
        });


        //hide zero reviews. Declared in global.j
        setTimeout(function () {
            hideZeroReviews();
        }, 5000)
        
    }


    //look for blocks with loading and remove them after results has been processed
    cleanProductContainer() {

        this.querySelectorAll(this.selectors.productItem + this.selectors.loading).forEach((item) => {
            item.remove();
        })
    }

    clearProductResults() {
        
        const $slider = $(this.productResultsContainer);

        if ($slider.hasClass('slick-initialized')) {
            $slider.slick("unslick");
        }
        
        this.querySelectorAll(this.selectors.productItem).forEach((item) => {
            item.innerHTML = '';
            item.classList.add(this.loadingClass);
        })
        
    }

    resizeContainer() {
        const contentContainerHeight = this.contentContainer.offsetHeight;
        const disclaimerContainerHeight = this.disclaimerContainer.offsetHeight;
        const spacing = 70;


        /*
        const containerHeight = contentContainerHeight + disclaimerContainerHeight + spacing;

        this.container.style.minHeight = `${containerHeight}px`;
        */


        //on mobile resize results container to fit mobile screen
        const windowWidth = window.innerWidth;
        if (windowWidth < 768) {
            
            const elementHeight = this.offsetHeight;
            const svh = window.innerHeight;

            const formHeight = this.form.offsetHeight;
            const titleContainerHeight = this.resultsTitleContainer.offsetHeight;
            const collectionContainerHeight = this.collectionResultsWrapper.offsetHeight;

            /*
            console.log(`elHeight`, elementHeight);
            console.log(`formHeight`, formHeight);
            console.log(`titleCOntianer`, titleContainerHeight);
            console.log(`collectionContainer`, collectionContainerHeight)
            console.log(`disclaimer`, disclaimerContainerHeight)
            console.log('minus', (formHeight + titleContainerHeight + disclaimerContainerHeight + collectionContainerHeight + (spacing * 2)));
            */

            const resultContainerHeight = Math.min(elementHeight, svh) - (formHeight + titleContainerHeight + disclaimerContainerHeight + collectionContainerHeight + (spacing * 2));

            this.productResultsContainer.style.minHeight = `${resultContainerHeight}px`
            this.productResultsContainer.style.maxHeight = `${resultContainerHeight}px`
        }
    }


    updateLiveRegion(productsCount = 0, collectionsCount = 0) {
      const liveRegion = this.querySelector('[data-ai-search-live-region-count-value]');
      if (liveRegion) {
        let messageParts = [];
    
        if (collectionsCount > 0) {
          messageParts.push(`${collectionsCount} collection${collectionsCount !== 1 ? 's' : ''}`);
        }
    
        if (productsCount > 0) {
          messageParts.push(`${productsCount} product${productsCount !== 1 ? 's' : ''}`);
        }
    
        const message = messageParts.length
          ? `${messageParts.join(' and ')} found`
          : `No results found`;
    
        liveRegion.textContent = message;
      }
    }


    scrollResultsIntoView() {
      const container = this.container;
      if (!container) return;
    
      const rect = container.getBoundingClientRect();
    
      // Already in view (with offset)?
      const offset = 60;
      const aboveTop = rect.top - offset;
      const belowBottom = rect.bottom - (window.innerHeight || document.documentElement.clientHeight);
    
      if (aboveTop >= 0 && belowBottom <= 0) {
        // Already in view (with offset)
        return;
      }
    
      // Get the absolute scroll position for the top of the container minus offset
      const scrollTo = window.scrollY + rect.top - offset;
    
      window.scrollTo({
        top: scrollTo,
        behavior: "smooth"
      });
    }


    /* ───────────────  State helpers ─────────────── */
    _resetPagination() {
        this.productsLoaded   = 0;       // how many we have rendered so far
        this.totalProducts    = 0;       // will be set on first response
        this.isFetchingMore   = false;
        this.hasMoreResults   = true;
    }

    /* Call this at the *end* of handleSearchReturn() */
    _updatePaginationInfo(pagination, productsLength) {
        this.productsLoaded += productsLength;
        this.totalProducts  = pagination?.total ?? this.productsLoaded;
        this.hasMoreResults = this.productsLoaded < this.totalProducts;
        
        console.log(`update pagination: loaded: ${this.productsLoaded}. Total: ${this.totalProducts}. Has more: ${this.hasMoreResults}`)
    }


    /* ------------------------------------------------------------------ */
    /*  Scroll watcher – fires when user nears bottom of the container    */
    /* ------------------------------------------------------------------ */

    //helper function for handling infinite scroll
    isNearBottom() {
        if (this.isFullPage == "true") {
            const footerH = document.querySelector('footer')?.getBoundingClientRect().height || 0;
            const doc = document.scrollingElement || document.documentElement;
            const viewportBottom = window.scrollY + window.innerHeight;
            const docHeight = Math.max(doc.scrollHeight, doc.clientHeight) - footerH;

            console.log('window: ', viewportBottom >= docHeight - this.INFINITE_SCROLL_THRESHOLD, footerH)
            return viewportBottom >= docHeight - this.INFINITE_SCROLL_THRESHOLD;
            
        } else {
            const el = this.productResultsContainer;
            return el.scrollTop + el.clientHeight >= el.scrollHeight - this.INFINITE_SCROLL_THRESHOLD;
        }
    }

    handleInfiniteScroll() {
        if (!this.hasMoreResults || this.isFetchingMore) return;

        
        if (!this.isNearBottom()) return;


        this.isFetchingMore = true;
        //calculate number of skeletons
        const skeletonNumber = Math.min(this.totalProducts - this.productsLoaded, this.productResultsLimit);
        this._appendLoadingSkeletons(skeletonNumber);   // visual feedback
        this._fetchNextPage()
            .finally(() => { this.isFetchingMore = false; });
    }

    
    /* ------------------------------------------------------------------ */
    /*  Fetch the next “page” of products                                 */
    /* ------------------------------------------------------------------ */
    _fetchNextPage() {
        const limit = this.productResultsLimit;
        const offset = this.productsLoaded;  
        const page = Math.floor(offset / limit);

        const locale = (window.theme.apiLocale || 'us').toLowerCase();
        const params = new URLSearchParams({
            search : this.currentSearch,
            searchId: this.currentSearchId,
            limit,
            page,         
            locale
        }).toString();

        const ctrl = this.fetchCtrl;
        return fetch(`${this.PRODUCT_FETCH_URL}?${params}`, {
                    credentials: 'include',
                    signal: ctrl.signal
                })
                .then(r => {
                    if (!r.ok) throw new Error(r.status);
                    return r.json();
                })
                .then(({ products = [], pagination = {} }) => {
                    /* Re-use your renderer but *append* this time */
                    this.handleProductResults(products, true);
                    this._updatePaginationInfo(pagination, products.length);


                    //analytics
                    // NEW: set a sentinel for this page so we log when it scrolls into view
                    //this.analyticsService.observePageByItem(page);

                    this.analyticsService.observeItemsInPage(page);

                }).finally(() => {
                    //remove all unused skeletons
                    this.cleanProductContainer();
                })
                .catch(err => {
                    if (err.name === 'AbortError') return;
                });
    }

    /* ------------------------------------------------------------------ */
    /*  Utilities                                                         */
    /* ------------------------------------------------------------------ */

    /** Creates the grey “loading” cards you already rely on */
    _appendLoadingSkeletons(count) {
        for (let i = 0; i < count; i++) {
            const skel = document.createElement('div');

            const skelTemplate = `
            <!-- image placeholder -->
            <div class="skeleton skeleton--image"></div>

            <!-- content -->
            <div class="index-search-result-item-content-container">
                <div class="skeleton skeleton--title"></div>
                <div class="skeleton skeleton--price"></div>
                <div class="skeleton skeleton--button"></div>
            </div>
            `

            skel.innerHTML = skelTemplate

            skel.classList.add(
                'index-search-result-item',
                'js-index-search-result-item',
                'glass-effect',
                this.loadingClass
            );
            this.productResultsContainer.appendChild(skel);
        }
    }

    /** Abort any old requests and return a fresh controller */
    _newFetchController() {
        if (this.fetchCtrl) this.fetchCtrl.abort();   // cancel leftovers
        this.fetchCtrl = new AbortController();
        return this.fetchCtrl;
    }

    /** ANALYTICS  */

    /** IMPRESSION FUNCTIONS */

    startView(handle) {
        this.analyticsService.startView(handle);
    }


    stopView(handle, reason = 'end') {
        this.analyticsService.stopView(handle, reason);
    }

    _stopAllViews(reason) {
        this.analyticsService._stopAllViews();
    }

    trackClick(handle) {
        this.analyticsService.trackClick(handle);
    }
      
    trackAddToCart(handle, qty = 1, priceAtAction) {
        this.analyticsService.trackAddToCart(handle, qty, priceAtAction);
    }
      
    trackPurchase(handle, qty = 1, priceAtAction) {
        this.analyticsService.trackPurchase(handle, qty, priceAtAction);
    }

    /** END ANALYTICS */
}
  
customElements.define('index-main-search', IndexMainSearch);